import React from 'react';
import Processus from '../components/Processus';

export default function Services() {
  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container">

          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Services
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* About Start */}
      <div className="container-fluid pb-5" style={{ backgroundColor: '#f4f8fc' }}>
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <h6 className="bg-transparent text-start pe-3 mb-3" style={{ color: '#01225C', fontSize: '18px', fontWeight: 'bold' }}>
                À Propos
              </h6>
              <h1 className="mb-4" style={{ color: '#01225C', fontSize: '32px', fontWeight: 'bold' }}>
                Bienvenue chez Aviator Travel Services
              </h1>
              <p className="mb-4" style={{ color: '#01225C', fontWeight: '500', fontSize: '15px' }}>
                Chez Aviator Travel Service – ATS Enaser, basés à Ariana, en Tunisie, nous nous spécialisons dans la création de voyages mémorables et d'expériences de voyage sur mesure pour les particuliers, les familles et les groupes.
              </p>
              <p className="mb-4" style={{ color: '#01225C', fontWeight: '500', fontSize: '15px' }}>
                Avec une passion pour l'exploration de nouvelles destinations et un engagement envers un service de haute qualité,
                nous vous aidons à découvrir à la fois des trésors locaux et des aventures internationales.
                Laissez-nous prendre en charge la planification de votre voyage, afin que vous puissiez vous concentrer sur le moment présent.
              </p>
              <div className="row gy-3 gx-4 mb-4">
                <div className="col-sm-7">
                  <p className="mb-0" style={{ color: '#01225C', fontWeight: '600', fontSize: '14.5px', whiteSpace: 'nowrap' }}>
                    <i className="fa fa-arrow-right me-2" style={{ color: '#FFBC1E' }} />
                    Réservation d'hôtels en Tunisie et à l'étranger
                  </p>
                </div>
                <div className="col-sm-5">
                  <p className="mb-0" style={{ color: '#01225C', fontWeight: '600', fontSize: '14.5px' }}>
                    <i className="fa fa-arrow-right me-2" style={{ color: '#FFBC1E' }} />
                    Billeterie
                  </p>
                </div>
                <div className="col-sm-7">
                  <p className="mb-0" style={{ color: '#01225C', fontWeight: '600', fontSize: '14.5px' }}>
                    <i className="fa fa-arrow-right me-2" style={{ color: '#FFBC1E' }} />
                    Voyages organisés
                  </p>
                </div>
                <div className="col-sm-5">
                  <p className="mb-0" style={{ color: '#01225C', fontWeight: '600', fontSize: '14.5px' }}>
                    <i className="fa fa-arrow-right me-2" style={{ color: '#FFBC1E' }} />
                    Sport dans le monde
                  </p>
                </div>
                <div className="col-sm-7">
                  <p className="mb-0" style={{ color: '#01225C', fontWeight: '600', fontSize: '14.5px' }}>
                    <i className="fa fa-arrow-right me-2" style={{ color: '#FFBC1E' }} />
                    Assistance visa et voyages
                  </p>
                </div>
                <div className="col-sm-5">
                  <p className="mb-0" style={{ color: '#01225C', fontWeight: '600', fontSize: '14.5px' }}>
                    <i className="fa fa-arrow-right me-2" style={{ color: '#FFBC1E' }} />
                    Gestion d'événements
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 wow fadeInUp text-center"
              data-wow-delay="0.3s"
            >
              <img
                className="img-fluid"
                src="assets/img/about.png"
                alt="Tour Eiffel"
                style={{
                  borderRadius: "15px",
                  width: "auto",
                  maxHeight: "550px",
                  objectFit: "contain"
                }}
              />
            </div>

          </div>
        </div>
      </div>
      {/* About End */}

      <Processus />

    </div>
  );
}
